module.exports = __webpack_public_path__ + "../resources/img/ic_fail_device_connection.3c7384ae.svg";